import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Box, Card, Tag, Text, Title } from '@nimbus-ds/components';
import { ChevronRightIcon } from '@nimbus-ds/icons';
import RedirectCardSkeleton from './RedirectCardSkeleton';

interface RedirectCardInterface {
  title: string;
  path: string;
  isNew?: boolean;
}

function RedirectCard({
  title,
  path,
  isNew = false,
}: RedirectCardInterface): JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();

  const redirectToInstallments = () => history.push(path);

  return (
    <Card padding="none">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        onClick={redirectToInstallments}
        cursor="pointer"
        padding="4"
      >
        <Title as="h4">{title}</Title>
        <Box
          paddingRight="2"
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          gap="2"
        >
          {isNew && (
            <Tag appearance="primary">
              <Text fontSize="caption">{t('configuration.newTag')}</Text>
            </Tag>
          )}
          <ChevronRightIcon />
        </Box>
      </Box>
    </Card>
  );
}

RedirectCard.Skeleton = RedirectCardSkeleton;

export default RedirectCard;
